import { limeApiGet } from "./api";
import { AuthContextProps } from "react-oidc-context";

export class FeatureFlagsResult {
    directDebitEnabled: boolean;
    resendMemberInviteEnabled: boolean;

    constructor(directDebitEnabled: boolean = false, resendMemberInviteEnabled: boolean = false) {
        this.directDebitEnabled = directDebitEnabled;
        this.resendMemberInviteEnabled = resendMemberInviteEnabled;
    }
}

export async function getFeatureFlag(auth: AuthContextProps) {
    if (!auth.isLoading && auth.isAuthenticated) {
        return await limeApiGet<FeatureFlagsResult>(`feature`, auth);
    }
    return new FeatureFlagsResult();
}
